import { gql } from "@apollo/client";

// ── Queries ──────────────────────────────────────────────────────────

export const GET_SESSION_STATUS = gql`
  query GetSessionStatus($bookingId: String!) {
    sessionStatus(bookingId: $bookingId) {
      session {
        id
        bookingId
        tenantId
        providerRoomSid
        roomName
        status
        recordingEnabled
        scheduledStart
        scheduledDurationMinutes
        startedAt
        endedAt
        elapsedSecondsBillable
        lastResumedAt
        createdAt
        updatedAt
        events {
          id
          sessionId
          eventType
          participantId
          participantRole
          participantName
          joinMethod
          occurredAt
        }
        accessCodes {
          id
          code
          participantRole
          participantId
          expiresAt
        }
      }
      accessCodes {
        id
        code
        bookingId
        sessionId
        tenantId
        participantRole
        participantId
        expiresAt
      }
      events {
        id
        sessionId
        eventType
        participantId
        participantRole
        participantName
        joinMethod
        occurredAt
      }
      ivrAttempts {
        id
        ani
        codeEntered
        success
        attemptedAt
      }
      notes {
        id
        sessionId
        bookingId
        authorId
        authorRole
        content
        createdAt
        updatedAt
      }
      actionItems {
        id
        sessionId
        bookingId
        authorId
        authorRole
        text
        isCompleted
        sortOrder
        createdAt
        updatedAt
      }
      overlappingPresenceSeconds
      overlappingPresenceMinutes
      tenantPhoneNumber
      recordingNoticeUrl
      recordingAvailable
      elapsedSecondsBillable
      timerPaused
    }
  }
`;

export const GET_TRANSCRIPT_EVENTS = gql`
  query GetTranscriptEvents($bookingId: String!) {
    transcriptEvents(bookingId: $bookingId) {
      id
      sessionId
      eventId
      participantIdentity
      utteranceText
      eventTimestamp
      confidence
      sequence
      createdAt
    }
  }
`;

// ── Mutations ────────────────────────────────────────────────────────

export const GENERATE_VIDEO_TOKEN = gql`
  mutation GenerateVideoToken($bookingId: ID!) {
    generateVideoToken(bookingId: $bookingId) {
      token
      roomName
      identity
      waitingRoom
      message
      scheduledStart
    }
  }
`;

export const TRIGGER_CALL_ME = gql`
  mutation TriggerCallMe($bookingId: ID!, $customerId: ID!) {
    triggerCallMe(bookingId: $bookingId, customerId: $customerId) {
      success
      error
    }
  }
`;

export const TRIGGER_CALL_ME_PROVIDER = gql`
  mutation TriggerCallMeProvider($bookingId: ID!) {
    triggerCallMeProvider(bookingId: $bookingId) {
      success
      error
    }
  }
`;

export const END_SESSION_MEETING = gql`
  mutation EndSessionMeeting($bookingId: ID!) {
    endSessionMeeting(bookingId: $bookingId) {
      success
      error
    }
  }
`;

export const SET_SESSION_RECORDING = gql`
  mutation SetSessionRecording($bookingId: ID!, $enabled: Boolean!) {
    setSessionRecording(bookingId: $bookingId, enabled: $enabled) {
      success
      recordingEnabled
      error
    }
  }
`;

export const SEND_SESSION_LINK = gql`
  mutation SendSessionLink($bookingId: ID!) {
    sendSessionLink(bookingId: $bookingId) {
      success
      error
    }
  }
`;

export const SAVE_SESSION_NOTES = gql`
  mutation SaveSessionNotes($bookingId: ID!, $content: String!) {
    saveSessionNotes(bookingId: $bookingId, content: $content) {
      id
      content
      updatedAt
    }
  }
`;

export const SAVE_SESSION_ACTION_ITEMS = gql`
  mutation SaveSessionActionItems($bookingId: ID!, $items: [ActionItemInput!]!) {
    saveSessionActionItems(bookingId: $bookingId, items: $items) {
      id
      text
      isCompleted
      sortOrder
      updatedAt
    }
  }
`;

export const LOG_NOTICE_PLAYED = gql`
  mutation LogNoticePlayed($bookingId: ID!) {
    logNoticePlayed(bookingId: $bookingId) {
      success
      error
    }
  }
`;

export const SAVE_TRANSCRIPT_EVENTS = gql`
  mutation SaveTranscriptEvents($bookingId: ID!, $events: [TranscriptEventInput!]!) {
    saveTranscriptEvents(bookingId: $bookingId, events: $events) {
      success
      persistedCount
      errors
    }
  }
`;

